import { render, staticRenderFns } from "./Seminars.vue?vue&type=template&id=a0847eca&"
import script from "./Seminars.js?vue&type=script&lang=js&"
export * from "./Seminars.js?vue&type=script&lang=js&"
import style0 from "./Seminars.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports